import { Entity } from "@common/types/entity";
import { ViewConfig } from "@lib/views";
import { LockStatusCell } from "./LockStatusCell";
import { LockEntityCell } from "./LockEntityCell";
import { LockDateCell } from "./LockDateCell";

export enum WorkspaceLockColumn {
    STATUS = "status",
    ENTITY = "entity",
    LOCK_DATE = "lockDate",
}

export const workspaceLockViewConfig: ViewConfig<
    Entity,
    WorkspaceLockColumn,
    never
> = {
    columns: {
        [WorkspaceLockColumn.STATUS]: {
            accessorKey: "id",
            name: "Status",
            header: "Status",
            cell: LockStatusCell,
            minSize: 80,
            maxSize: 80,
        },
        [WorkspaceLockColumn.ENTITY]: {
            accessorKey: "name",
            name: "Entity",
            header: "Entity",
            cell: LockEntityCell,
            minSize: 200,
            maxSize: 1000,
        },
        [WorkspaceLockColumn.LOCK_DATE]: {
            accessorKey: "id",
            name: "Lock up to",
            header: "Lock up to",
            cell: LockDateCell,
            minSize: 300,
            maxSize: 300,
        },
    },
};
